import React, { useState } from 'react';
import './styles.css';
import { Stack, useTheme } from '@mui/system';
import { Box, Card, CardMedia, Typography } from '@mui/material';
import Carousel from 'react-material-ui-carousel';

const items = [
  {
    name: '1. The Game Header',
    imageUrl:
      'https://res.cloudinary.com/dqlqwdqs9/image/upload/v1690137522/Tutorial1_vfnorl.png',
  },
  {
    name: '2. The Question and Answer Reveal',
    imageUrl:
      'https://res.cloudinary.com/dqlqwdqs9/image/upload/v1690137522/Tutorial2_qz9wxo.png',
  },
  {
    name: '3. Submitting Your Answer',
    imageUrl:
      'https://res.cloudinary.com/dqlqwdqs9/image/upload/v1690137522/Tutorial3_zfgmlz.png',
  },
  {
    name: '4. The Scoring',
    imageUrl:
      'https://res.cloudinary.com/dqlqwdqs9/image/upload/v1690137522/Tutorial4_pwjbk3.png',
  },
];

export const HowToPlay = () => {
  const theme = useTheme();
  const [firstImgLoaded, setFirstImgLoaded] = useState(false);
  return (
    <Stack spacing={1}>
      <Typography variant="h4" textAlign={'center'} letterSpacing={5}>
        HOW TO PLAY
      </Typography>
      <img
        src={items[0].imageUrl}
        onLoad={() => setFirstImgLoaded(true)}
        style={{ display: 'none' }}
        alt="first"
      />
      {firstImgLoaded && (
        <Carousel navButtonsAlwaysVisible autoPlay={false}>
          {items.map((item, i) => (
            <Box
              sx={{
                justifyContent: 'center',
              }}
            >
              <Stack spacing={2} sx={{ display: 'flex', alignItems: 'center' }}>
                <Typography variant="h6">{item.name}</Typography>
                <Card variant="outlined" sx={{ paddingY: 2 }}>
                  <CardMedia
                    component="img"
                    image={item.imageUrl}
                    alt={item.name}
                  />
                </Card>
              </Stack>
            </Box>
          ))}
        </Carousel>
      )}
      <Box paddingTop={2}>
        <Typography variant="h4" textAlign={'center'} letterSpacing={5}>
          HOW SCORING WORKS
        </Typography>
        <Typography
          component="h1"
          variant="h6"
          sx={{ textAlign: 'center', marginTop: 2, marginBottom: 2 }}
        >
          In PAR, lower scores are better. Like in golf.
        </Typography>
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <img
            style={{ width: '80%', marginLeft: '20px' }}
            src={'./par-scoring.svg'}
            alt="number-line"
          ></img>
        </div>
        <Typography
          component="h1"
          variant="h6"
          sx={{ textAlign: 'center', marginTop: 3, marginBottom: 2 }}
        >
          Example:
        </Typography>
        <Typography
          component="h1"
          variant="h6"
          sx={{ textAlign: 'center', marginTop: 2, marginBottom: 2 }}
        >
          A question with a PAR <strong>5</strong> means:
        </Typography>
        <Box sx={{ textAlign: 'center' }}>
          <Typography component="h1" variant="h6" sx={{ marginTop: 2 }}>
            answering in <strong>6</strong> seconds scores a <strong>+1</strong>
          </Typography>
          <Typography component="h1" variant="h6" sx={{ marginTop: 2 }}>
            answering in <strong>5</strong> seconds scores a {'\u00A0'}
            <strong>0</strong>
          </Typography>
          <Typography component="h1" variant="h6" sx={{ marginTop: 2 }}>
            answering in <strong>4</strong> seconds scores a <strong>-1</strong>
          </Typography>
        </Box>
        <Typography
          component="h1"
          variant="h6"
          sx={{ textAlign: 'center', marginTop: 2, marginBottom: 2 }}
        >
          etc.
        </Typography>
      </Box>
    </Stack>
  );
};

// function useParallax(value: MotionValue<number>, distance: number) {
//   return useTransform(value, [0, 1], [-distance, distance]);
// }

// function Image({ id }: { id: number }) {
//   const ref = useRef(null);
//   const { scrollYProgress } = useScroll({ target: ref });
//   const y = useParallax(scrollYProgress, 300);

//   return (
//     <section className="how-to-section">
//       <div ref={ref}>
//         <img
//           className="how-to-image"
//           src={`./par${id}.png`}
//           alt="A London skyscraper"
//         />
//       </div>
//       <motion.h2 style={{ y }}>{`#00${id}`}</motion.h2>
//     </section>
//   );
// }

// export const HowToPlay = () => {
//   const { scrollYProgress } = useScroll();
//   const scaleX = useSpring(scrollYProgress, {
//     stiffness: 100,
//     damping: 30,
//     restDelta: 0.001,
//   });

//   return (
//     <Container>
//       {[1, 2, 3].map((image) => (
//         <Image id={image} />
//       ))}
//       <motion.div className="progress" style={{ scaleX }} />
//     </Container>
//   );
// };
